
import { Options, Vue } from "vue-class-component";
import { ListStt } from "@/domain/entities/ListPickupDetailV2";
import { Pagination } from "@/domain/entities/Pagination";
import Title from "@/app/ui/components/data-wrapper/title.vue";

class Props {
  listStt = [] as ListStt[];
  loading = false as boolean;
}

@Options({
  name: "PickupDetailSttTable",
  components: {
    Title
  },
  watch: {
    listStt: {
      handler: "onListSttChange",
      immediate: true,
      deep: true
    }
  }
})
export default class PickupDetailSttTable extends Vue.with(Props) {
  pagination = new Pagination(1, 10, 0);

  onListSttChange(newList: ListStt[]) {
    this.pagination.totalData = newList.length;
  }

  get columns() {
    return [
      {
        name: this.$t("pickup.detail.stt.table.colNo"),
        headerId: "pickup-detail-stt-col-no",
        styleHead: "w-14 text-center whitespace-no-wrap",
        styleCustom: "text-center",
        render: (_: any, index: number) => {
          const pageOffset = (this.pagination.page - 1) * this.pagination.limit;
          return `<div class="text-black-lp-300">${pageOffset + index + 1}</div>`;
        },
      },
      {
        name: this.$t("pickup.detail.stt.table.colSttNo"),
        headerId: "pickup-detail-stt-col-stt-no",
        styleHead: "w-40 text-left whitespace-no-wrap",
        render: (item: ListStt) => {
          return `<div class="text-black-lp-300">${item.sttNo || "-"}</div>`;
        },
      },
      {
        name: this.$t("pickup.detail.stt.table.colKoli"),
        headerId: "pickup-detail-stt-col-koli",
        styleHead: "w-24 text-center whitespace-no-wrap",
        styleCustom: "text-center",
        render: (item: ListStt) => {
          return `<div class="text-black-lp-300">${item.totalKoli || 0}</div>`;
        },
      },
      {
        name: this.$t("pickup.detail.stt.table.colBerat"),
        headerId: "pickup-detail-stt-col-berat",
        styleHead: "w-28 text-center whitespace-no-wrap",
        styleCustom: "text-center",
        render: (item: ListStt) => {
          return `<div class="text-black-lp-300">${this.$t(
            "pickup.detail.stt.table.weightSuffix",
            { weight: item.grossWeight || 0 }
          )}</div>`;
        },
      },
    ];
  }
}
